<template>
  <transition name="fade">

    <div class="business-page">
      <div class="section-container" id="business-fullpage">
        <section class="landing-screen market-screen business-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-cultrue">
           <div class="text-cultrue fade-in" v-view>
              <div class="headline-1"><b>核心业务</b></div>
              <div class="description">
                绿展在运营过程中，通过自身的科技集成与资源整合能力，提供高附加值解决方案，满足客户的综合技术需求，并实现项目地方落地，解决我国产业痛点，完成投资退出。
              </div>
             </div>
            <div class="circle-container">
           <div class="circle lightgreen-gradient-bg">
              <div class="circle-col-3">1</div>
              <div class="circle-col-1"><b>公共工程项目的<br/>系统集成</b></div>
            </div>
            <div class="circle lightgreen-gradient-bg">
              <div class="circle-col-3">2</div>
              <div class="circle-col-1"><b>国际技术<br/>落地国产化</b></div>
            </div>
            <div class="circle lightgreen-gradient-bg">
              <div class="circle-col-3">3</div>
              <div class="circle-col-1"><b>科技项目的<br/>投资与孵化</b></div>
            </div>
            <div class="circle lightgreen-gradient-bg">
              <div class="circle-col-3">4</div>
              <div class="circle-col-1"><b>消费级市场<br/>产品实现</b></div>
            </div>
            <div class="circle lightgreen-gradient-bg">
              <div class="circle-col-3">5</div>
              <div class="circle-col-1"><b>文化IP的<br/>投资</b></div>
            </div>
         </div>
          </div>
        </section>
       <section class="landing-screen market-screen business-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1">
                   <b>绿展模式</b>
                </div>
                <div class="description">
                <p>① <b>需求</b>——To G（政府）To B（企业）To C（用户）</p>
                <p>② <b>产品</b>——国际项目引进；国内方案集成</p>
                <p>③ <b>适配</b>——公共工程项目、本地化</p>
                <p>④ <b>落地</b>——投资；销售；代工；技术研发</p>
                <p>⑤ <b>渠道</b>——开发；维护</p>
              </div>
            </div>
            </div>
             <div class="approach-logo1">
            <img src="../assets/loop.png" alt=""/>
            </div>
            </div>
        </section>
         <section class="landing-screen market-screen business-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-container">
            <div class="col">
              <div class="text-container fade-in" v-view>
                <div class="headline-1">
                   <b>甄选全球 落地中国</b>
                </div>
                <div class="description">
                <p>① <b>国际项目池</b>——孵化器/高校技术转移中心/风投基金/世界500强战略投资部/<br>行业人士/政府</p>
                <p>② <b>GP筛选标准</b>——已工业化/已小批量/在海外已有客户有技术壁垒/可国产化</p>
                <p>③ <b>聚焦领域</b>——新兴产业/分散但可整合的</p>
                <p>④ <b>国内客户/市场需求</b>——To-G/To-B/To-C</p>
                </div>
              </div>
            </div>
            <div class="col approach-logo1">
            <img src="../assets/funnel.png" alt=""/>
          </div>
            </div>
        </section>
        <section class="landing-screen market-screen business-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-cultrue ">
           <div class="flex-bridge" id="flex-bridge">
               <div class="text-bridge fade-in" v-view id="text-bridge">
                 <div class="headline-1"><b>产业连接 生态共赢</b></div>
                 <div class="description">
                 连接全球优质科创成果及中国市场形成共赢的产业生态。
                 </div>
               </div>
              <div class="pic-bridge" id="pic-bridge"><img src="../assets/bridge.png"></div>
             </div>
           <div class="circle-container">
            <div class="circle-2">
            <div class="arrow-up"></div>
            <div class="headline-4"><b>GP全球<br/>离岸创新中心</b></div>
            <div class="headline-5">（硅谷/波士顿/伦敦/柏林...）</div>
            </div>
            <div class="circle-2">
            <div class="arrow-up"></div>
            <div class="headline-4"><b>GP中国<br/>央企合作大平台</b></div>
            <div class="headline-5">（中国普天/中国电子/中安网脉...）</div>
            </div>
            <div class="circle-2">
            <div class="arrow-up"></div>
            <div class="headline-4"><b>GP中国<br/>地方产业基地</b></div>
            <div class="headline-5">（深圳/佛山/珠海/北京...）</div>
            </div>
            <div class="circle-2">
            <div class="headline-4"><b>GP中国<br/>地方落地项目</b></div>
            <div class="headline-5">(粤港澳大湾区)</div>
            </div>
           </div>
          </div>
        </section>
        <section class="landing-screen market-screen business-slider section" id="landingScreen" v-view="hidePitfall">
          <div class="flex-cultrue">
           <div class="text-cultrue fade-in" v-view>
             <div class="headline-1"><b>合作伙伴</b></div>
             <div class="pic-partners">
               <span class="partners-logo"><img src="../assets/partners/1.png"></span>
                <span class="partners-logo"><img src="../assets/partners/2.png"></span>
               <span class="partners-logo"><img src="../assets/partners/3.png"></span>
               <span class="partners-logo"><img src="../assets/partners/4.png"></span>
               <span class="partners-logo"><img src="../assets/partners/5.png"></span>
             </div>
             <div class="pic-partners">
               <span class="partners-logo"><img src="../assets/partners/6.png"></span>
               <span class="partners-logo"><img src="../assets/partners/7.png"></span>
               <span class="partners-logo"><img src="../assets/partners/8.png"></span>
               <span class="partners-logo"><img src="../assets/partners/9.png"></span>
               <span class="partners-logo"><img src="../assets/partners/10.png"></span>
             </div>
         <div class="pic-partners">
               <span class="partners-logo"><img src="../assets/partners/11.png"></span>
               <span class="partners-logo"><img src="../assets/partners/12.png"></span>
               <span class="partners-logo"><img src="../assets/partners/13.png"></span>
               <span class="partners-logo"><img src="../assets/partners/14.png"></span>
               <span class="partners-logo"><img src="../assets/partners/15.png"></span>
             </div>
             <div class="pic-partners">
               <span class="partners-logo"><img src="../assets/partners/16.png"></span>
               <span class="partners-logo"><img src="../assets/partners/17.png"></span>
               <span class="partners-logo"><img src="../assets/partners/18.png"></span>
               <span class="partners-logo"><img src="../assets/partners/19.png"></span>
               <span class="partners-logo"><img src="../assets/partners/20.png"></span>
             </div>
           </div>
          </div>
                 <GPFooter/>
        </section>
      </div>

   </div>
  </transition>
</template>

<style lang="scss" src="./Business.scss">
</style>
<script>
import Fullpage from 'fullpage.js'
export default {
  name: 'Business',
  props: {},
  data () {
    return {
      businessSliders: null,
      isPitfallHide: true
    }
  },
  methods: {
    formatter (num) {
      return num.toFixed(1)
    },
    animStart (e, n) {
      this.$refs[`teamNum_${n}`].start()
    },
    hidePitfall () {
      this.isPitfallHide = true
    },
    showPitfall () {
      this.isPitfallHide = false
    },
    resizeEvent (e) {
      e.stopPropagation()
      if (document.body.offsetWidth > 1024 && this.businessSliders === null) {
        this.initFullPage()
      }
    },
    initFullPage () {
      this.businessSliders = new Fullpage('#business-fullpage', {
        licenseKey: 'FAE6D29E-C9664B70-A1915489-3CEF9EF7',
        autoScrolling: true,
        lazyLoading: true,
        easingcss3: 'cubic-bezier(0.75, 0, 0.25, 1)',
        fitToSectionDelay: 180,
        fadingEffect: false,
        animateAnchor: false,
        scrollingSpeed: 800,
        scrollBar: true,
        navigation: true,
        navigationPosition: 'left',
        afterResize: (width, height) => {
          if (width < 1024) {
            this.businessSliders.destroy('all')
            this.businessSliders = null
          }
        }
      })
    }
  },
  created () {
  },
  destroyed () {
    if (this.businessSliders !== null) {
      this.businessSliders.destroy('all')
      this.businessSliders = null
    }
    window.removeEventListener('resize', this.resizeEvent)
  },
  mounted () {
    window.addEventListener('resize', this.resizeEvent)
    if (document.body.offsetWidth > 1024 && this.businessSliders === null) {
      this.initFullPage()
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Business.vue